var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeInitialProjectEvaluation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 132.13 115.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{opacity:.8;}.cls-3{opacity:.15;}.cls-4,.cls-5{fill:rgba(255,255,255,.47);}.cls-6{fill:url(#linear-gradient);}.cls-5,.cls-7{stroke:#fff;stroke-miterlimit:10;}.cls-7{fill:none;stroke-linecap:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.41,
    y1: 53.69,
    x2: 82.8,
    y2: 53.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.63,6.16V99.78c0,8.3-6.46,15.37-14.75,15.67-.19,.01-.38,.01-.56,.01H24.9c.19,0,.38,0,.56-.01,8.3-.3,14.75-7.37,14.75-15.67V6.16c0-3.13,2.53-5.66,5.66-5.66H125.97c3.12,0,5.66,2.53,5.66,5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.32,115.46H24.89c-8.45,0-15.31-6.86-15.31-15.31v-10.04c0-2.92,2.37-5.28,5.28-5.28H95.72c2.91,0,5.28,2.36,5.28,5.28v10.04c0,8.45,6.86,15.31,15.32,15.31Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.71 32.18 48.93 32.18 48.93 23.18 71.19 23.18 77.71 32.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.14,
    y: 25.18,
    width: 46.96,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.93,
    y: 39.35,
    width: 28.78,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.14,
    y: 41.35,
    width: 46.96,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.32 64.37 48.93 64.37 48.93 55.37 77.71 55.37 63.32 64.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "123.11 62.37 61.53 62.37 76.14 57.37 123.11 57.37 123.11 62.37"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.52,20.93c-10.57-10.57-27.7-10.58-38.27,0-9.55,9.56-10.46,24.5-2.7,35.08l-6.6,6.6-.74-.74v16.94l8.47-8.47-1.84-1.84,6.6-6.6c10.57,7.75,25.51,6.86,35.08-2.71,10.56-10.57,10.55-27.69,0-38.25Zm-5.11,33.14c-6.74,6.73-17.1,7.61-24.78,2.63-1.16-.74-2.26-1.62-3.26-2.63-1.01-1-1.89-2.1-2.64-3.25-4.98-7.69-4.1-18.06,2.63-24.79,7.75-7.74,20.31-7.74,28.05,0,7.75,7.74,7.74,20.3,0,28.04ZM24.63,94.38l9.55-9.55H15.08l9.55,9.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.77,54.07c-6.74,6.73-17.1,7.61-24.78,2.62-1.16-.74-2.25-1.61-3.26-2.62-1.01-1.01-1.89-2.1-2.64-3.25-4.98-7.68-4.1-18.06,2.63-24.79,7.75-7.74,20.31-7.74,28.05,0,7.75,7.75,7.74,20.3,0,28.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.88,20.93c-10.57-10.57-27.69-10.58-38.26,0-9.56,9.56-10.46,24.5-2.71,35.08l-6.59,6.6-1.85-1.85L1.41,84.8l9.58,9.58,24.05-24.05-1.84-1.84,6.59-6.6c10.58,7.76,25.51,6.86,35.08-2.71,10.57-10.57,10.56-27.69,0-38.25Zm-5.11,33.14c-6.74,6.73-17.1,7.61-24.78,2.62-1.16-.74-2.25-1.61-3.26-2.62-1.01-1.01-1.89-2.1-2.64-3.25-4.98-7.68-4.1-18.06,2.63-24.79,7.75-7.74,20.31-7.74,28.05,0,7.75,7.75,7.74,20.3,0,28.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.74,15c6.69,0,12.99,2.61,17.73,7.34,4.73,4.73,7.33,11.02,7.34,17.71,0,6.69-2.6,12.98-7.34,17.71-4.73,4.73-11.02,7.34-17.7,7.34-5.36,0-10.48-1.67-14.78-4.83l-1.38-1.02-1.21,1.21-6.59,6.6-1.41,1.41,1.41,1.41,.43,.43-21.23,21.23-6.75-6.75,21.22-21.23,.43,.43,1.41,1.41,1.41-1.42,6.59-6.6,1.21-1.21-1.01-1.38c-7.34-10.02-6.29-23.69,2.51-32.49,4.73-4.73,11.02-7.33,17.71-7.33m.02,46.88c5.82,0,11.3-2.27,15.43-6.39,8.51-8.52,8.51-22.37,0-30.87-4.12-4.12-9.6-6.39-15.44-6.39s-11.32,2.27-15.44,6.39c-7.23,7.24-8.45,18.72-2.89,27.29,.83,1.28,1.81,2.48,2.9,3.58,1.09,1.1,2.3,2.07,3.59,2.89,3.53,2.29,7.63,3.5,11.86,3.5m-.02-48.88c-6.92,0-13.84,2.64-19.12,7.92-9.56,9.56-10.46,24.5-2.71,35.08l-6.59,6.6-1.85-1.85L1.41,84.8l9.58,9.58,24.05-24.05-1.84-1.84,6.59-6.6c4.74,3.47,10.35,5.21,15.96,5.21,6.92,0,13.83-2.64,19.12-7.92,10.57-10.57,10.56-27.69,0-38.25-5.29-5.29-12.22-7.93-19.14-7.93h0Zm.02,46.88c-3.75,0-7.5-1.06-10.77-3.18-1.16-.74-2.25-1.61-3.26-2.62-1.01-1.01-1.89-2.1-2.64-3.25-4.98-7.68-4.1-18.06,2.63-24.79,3.87-3.87,8.95-5.8,14.03-5.8s10.15,1.93,14.02,5.8c7.75,7.75,7.74,20.3,0,28.05-3.87,3.87-8.94,5.8-14.01,5.8h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46,30.3c-2.14,2.14-3.52,4.92-3.92,7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.5,30.3c-3.18-3.18-7.59-4.47-11.77-3.87"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeInitialProjectEvaluation);
export default __webpack_public_path__ + "static/media/free-initial-project-evaluation.8ce073887c4124c20658a864c158c536.svg";
export { ForwardRef as ReactComponent };